import React, { useEffect, useState } from "react";
import { Box } from '@mui/material';
import {  useSelector } from 'react-redux';
import CardTable from 'components/CardTable/CardTable';
import { useClosed, useWaitingClose } from './columns';
import { TabContext } from '@mui/lab';
import { useSearch } from "hooks/useSearch";
import { PERMISSIONS } from "router/permissions";
import { TabPanel, Tab, TabList } from "./styles"
import { PercentageBar } from "./percentageBar";
import { useRuleValidator } from "hooks/useRuleValidator";

const tableKeyWaiting = 'waitingUnitsTable'
const tableKeyClosed = 'closedUnitsTable'

export default function InventoryStatusTabs() {
    const { inventoryComplete, inventoryIncomplete, isInventoryClosed, date, inventoryPercentage } = useSelector(({ inventoryStatus }) => inventoryStatus);
    const { isLoadingComp, configTables } = useSelector(({ search }) => search);
    const { buildTableConfig } = useSearch();
    const [value, setValue] = useState("1");
    const handleChange = (event, value) => setValue(value);
    const { DIGITAL_INVENTORIES_DELETE, DIGITAL_INVENTORIES_ACTIONS } = PERMISSIONS;
    const showActions = useRuleValidator(DIGITAL_INVENTORIES_ACTIONS);
    const ruleDelete = useRuleValidator(DIGITAL_INVENTORIES_DELETE);

    useEffect(() => {
        !configTables[tableKeyWaiting] && buildTableConfig(tableKeyWaiting)
        !configTables[tableKeyClosed] && buildTableConfig(tableKeyClosed)
    }, [])

    return (
        <Box style={{ width: '100%' }}>
            <TabContext value={value}>
                <TabList onChange={handleChange} variant="fullWidth" aria-label="Inventory Status Tabs">
                    <Tab value="1" label="Detalle unidades faltantes de cierre" />
                    <Tab value="2" label="Detalle unidades cerradas" />
                </TabList>
                <TabPanel value="1">
                    <CardTable
                        data={inventoryIncomplete}
                        columns={useWaitingClose(showActions, isInventoryClosed, date, inventoryPercentage, inventoryComplete)}
                        loading={isLoadingComp?.loadingInventoryStatus}
                        blockBtn
                        tableKey={tableKeyWaiting}
                        tableContent={<PercentageBar inventoryPercentage={inventoryPercentage} />}
                    />
                </TabPanel>
                <TabPanel value="2">
                    <CardTable
                        key={inventoryComplete.length + JSON.stringify(inventoryComplete)}
                        data={inventoryComplete}
                        columns={useClosed(showActions, isInventoryClosed, date, inventoryPercentage, inventoryComplete, ruleDelete)}
                        loading={isLoadingComp?.loadingInventoryStatus}
                        blockBtn
                        tableKey={tableKeyClosed}
                        tableContent={<PercentageBar inventoryPercentage={inventoryPercentage} />}
                    />
                </TabPanel>
            </TabContext>
        </Box>
    );
}

